<template>
  <header :style="{height:wrapHeight}">
    <div class="clearfix white wrap nav">
      <a href="/">
        <img class="pull-left logo" src="./images/logo.png" />
      </a>
      <div class="pull-left name">帮助中心</div>
      <ul class="ul-cls pull-left link">
        <li v-for="(item, index) in columns" :key="item.id">
          <router-link v-if="index === 0" to="/" exact>
            {{item.name}}
          </router-link>
          <router-link @click.native="link(item.id)" v-else-if="item.id !=='4'" :to="`/${item.id}`">
            {{item.name}}
          </router-link>
        </li>
      </ul>
      <div class="pull-right user">
        <template v-if="userInfo.id">
          <span class="pull-left">您好：{{userInfo.realName || userInfo.loginName}}</span>
          <a :href="logout" v-show="isShowExit" class="pull-left logout">退出</a>
        </template>
        <template v-else>
<a :href="reg"  v-show="isShowExit" class="pull-left text-center reg" target="_blank">注册</a>
          <a :href="enter"  v-show="isShowExit" class="pull-left">登录</a>
        </template>
      </div>
    </div>
    <div class="line" />
    <Search class="search" />
  </header>
</template>

<style lang="scss" scoped>
@import './style.scss';
</style>

<script>
import { mapState } from 'vuex';
import Search from './components/Search';

export default {
  name: 'Header',
  components: {
    Search,
  },
  data() {
    return {
      wrapHeight: '342px',
      reg: `${process.env.VUE_APP_PASSPORT}register/user`,
      enter: `${process.env.VUE_APP_CAS}cas/login.html?service=${process.env.VUE_APP_WO}&systemId=12&retUrl=${window.location.href}`,
      logout: `${process.env.VUE_APP_CAS}cas/logout?service=${window.location.origin}`,
      isIndex: true,
      isShowExit: true,
    };
  },
  computed: mapState({
    columns: state => state.app.columns,
    userInfo: state => state.app.userInfo,
  }),
  watch: {
    $route(to) {
      if (to.path === '/') {
        this.wrapHeight = '342px';
      } else {
        this.wrapHeight = '280px';
      }
    },
  },
  created() {
    if (this.$route.path === '/') {
      this.wrapHeight = '342px';
    } else {
      this.wrapHeight = '280px';
    }
    this.isShowExit = !(window.electron && window.electron.isIAPClient());
  },
  methods: {
    link(id) {
      this.$store.commit('app/setNavIndex', this.columns.findIndex(item => item.id === id));
    },
  },
};
</script>
